module.exports = __webpack_public_path__ + "img/logolabeyriev2.2dc31e5.png";